// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__2g5qj","Socials":"Footer_Socials__24uuD","Buttons":"Footer_Buttons__2DF1Z","FondyLink":"Footer_FondyLink__q9m1w"};